import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-igla",
  "use": "icon-igla-usage",
  "viewBox": "0 0 129 77",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 129 77\" id=\"icon-igla\"><path d=\"M1.138 76.299l-.5-.866 124.707-72 .5.866z\" /><path d=\"M122 3.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zM39 52.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol